<template>
  <span class="VueTables__sort ml-2">
    <component v-if="props.sortable" :is="icon" />
  </span>
</template>

<script>
import {
  BIconChevronDown,
  BIconChevronUp,
  BIconArrowDownUp,
} from "bootstrap-vue";

export default {
  name: "VtSortControl",
  components: {
    BIconChevronDown,
    BIconChevronUp,
    BIconArrowDownUp,
  },
  props: ["props"],
  computed: {
    icon() {
      // if not sorted return base icon
      if (!this.props.sortStatus.sorted) return "BIconArrowDownUp";
      // return sort direction icon
      return this.props.sortStatus.asc ? "BIconChevronUp" : "BIconChevronDown";
    },
  },
};
</script>

<style>
::-webkit-scrollbar {
  width: 3px;
  height: 5px;
}
::-webkit-scrollbar-track {
  border-radius: 50px;
  background: #eee;
}
::-webkit-scrollbar-thumb {
  border-radius: 50px;
  background: #bbb;
}
::-webkit-scrollbar-thumb:window-inactive {
  border-radius: 20px;
  background: #eee;
}
</style>